// extracted by mini-css-extract-plugin
module.exports = {"header":"ChatHeader_header__ne_fl"};